// extracted by css-extract-rspack-plugin
export default {"footer":"EmptyState-module__footer____KN8_","illustration":"EmptyState-module__illustration___rUSIR"};